<template>
    <div class="tutorial">
        <div
            v-for="(item, index) in STEPS"
            class="step d-flex align-content-md-center align-items-md-center"
            v-scroll-show
        >
            <div
                class="oval mr-3 ml-3"
                :class="{
                    'order-last': (index +1) % 2 === 0
               }"
            >
                <b-img
                    fluid
                    width="300"
                    :src="item.image"
                    class="step-image"
                />
            </div>
            <div
                class="step-body"
                :class="[(index +1) % 2 !== 0 ? 'ml-auto' : 'mr-auto']"
            >
                <h3 class="text-teal">
                    STEP {{ index + 1 }}
                </h3>
                <h1 class="title">
                    {{ item.title }}
                </h1>
                <p class="description">
                    {{ item.description }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import './Tutorial.scss';
import './Tutorial.mobile.scss';
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

const STEPS = [
    {
        image: require('../../../../../assets/images/trade/get-approved.png'),
        title: 'Get approved',
        description: 'Get approved for a specific amount so you can start shopping. Plus, you\'ll get a preliminary ' +
            'floor price so you\'ll have certainty your existing home will sell no matter what.'
    },
    {
        image: require('../../../../../assets/images/trade/make-an-ofer.png'),
        title: 'Make an offer',
        description: 'Work with me to make a cash offer on your new home. I can even shop based on your new estimated' +
            ' monthly payment.'
    },
    {
        image: require('../../../../../assets/images/trade/win-the-home.png'),
        title: 'Win the home',
        description: 'Once we’re under contract, I’ll guide you in conducting due diligence and securing your new home.'
    },
    {
        image: require('../../../../../assets/images/trade/move-in.png'),
        title: 'Move in',
        description: 'Complete the purchase of your new home so you can move in or start renovations immediately.'
    },
    {
        image: require('../../../../../assets/images/trade/list-and-sell.png'),
        title: 'List & sell your existing home',
        description: 'If you haven’t already, list your home and sell it for top dollar. In the unlikely event that ' +
            'your home doesn’t sell in 6 months, you can sell it at the pre-agreed upon floor price.'
    },
    {
        image: require('../../../../../assets/images/trade/onward.png'),
        title: 'Onward!',
        description: 'Now that you\'ve sold your existing home, you\'ll have a traditional mortgage at a competitive' +
            ' rate on your new home.'
    },
]
export default {
    name: "Tutorial",
    data() {
        return {
            STEPS
        }
    },
    mixins: [
        IsMobileMixin,
    ],

}
</script>
